const BOOKING_ATTRIBUTION_KEYS = [
  "promo",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
] as const;

const FACEBOOK_PROMO_CONTENT_VALUES = new Set(["discount", "price"]);

function normalizeParam(value: string | null): string {
  return value?.trim() ?? "";
}

export function derivePromoCodeFromSearchParams(
  searchParams: URLSearchParams,
): string {
  const explicitPromo = normalizeParam(searchParams.get("promo"));
  if (explicitPromo) return explicitPromo;

  const utmSource = normalizeParam(searchParams.get("utm_source")).toLowerCase();
  const utmMedium = normalizeParam(searchParams.get("utm_medium")).toLowerCase();
  const utmCampaign = normalizeParam(searchParams.get("utm_campaign"));
  const utmContent = normalizeParam(searchParams.get("utm_content")).toLowerCase();

  const isFacebookEntry = utmSource === "facebook";
  const isSupportedMedium =
    !utmMedium ||
    utmMedium === "leads" ||
    utmMedium === "cpc" ||
    utmMedium === "paid_social" ||
    utmMedium === "social";
  const isPromoContent =
    !utmContent || FACEBOOK_PROMO_CONTENT_VALUES.has(utmContent);

  if (isFacebookEntry && isSupportedMedium && isPromoContent && utmCampaign) {
    return utmCampaign;
  }

  return "";
}

export function buildBookingPathWithAttribution(
  basePath: string,
  currentSearch: string,
  extraParams: Record<string, string | null | undefined> = {},
): string {
  const [pathname, existingSearch = ""] = basePath.split("?");
  const nextParams = new URLSearchParams(existingSearch);
  const currentParams = new URLSearchParams(currentSearch);

  for (const key of BOOKING_ATTRIBUTION_KEYS) {
    const value = normalizeParam(currentParams.get(key));
    if (value) nextParams.set(key, value);
  }

  const derivedPromo = derivePromoCodeFromSearchParams(currentParams);
  if (derivedPromo && !normalizeParam(nextParams.get("promo"))) {
    nextParams.set("promo", derivedPromo);
  }

  for (const [key, value] of Object.entries(extraParams)) {
    const normalizedValue = value?.trim();
    if (normalizedValue) {
      nextParams.set(key, normalizedValue);
    } else {
      nextParams.delete(key);
    }
  }

  const query = nextParams.toString();
  return query ? `${pathname}?${query}` : pathname;
}
